import type { IconData } from '@stacksjs/iconify-core'

export const userGenderFemale: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.91 7.62h1.52v7.62h-1.52Zm-1.53 7.62h1.53v3.04h-1.53Zm0-10.67h1.53v3.05h-1.53Zm-1.52 13.71h1.52v1.53h-1.52Zm0-15.23h1.52v1.52h-1.52Zm-3.05 16.76h3.05v1.52h-3.05Zm0-18.29h3.05v1.53h-3.05Zm-7.62 19.81v1.53h3.05v4.57h-3.05v1.52h3.05V32h1.52v-3.05h3.05v-1.52h-3.05v-4.57h3.05v-1.53zm0-21.33h7.62v1.52h-7.62ZM9.15 19.81h3.04v1.52H9.15Zm0-18.29h3.04v1.53H9.15ZM7.62 18.28h1.53v1.53H7.62Zm0-15.23h1.53v1.52H7.62ZM6.1 15.24h1.52v3.04H6.1Zm0-10.67h1.52v3.05H6.1ZM4.57 7.62H6.1v7.62H4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default userGenderFemale
